export default __webpack_public_path__ + "static/media/placeholder.8cf2e824.webp";